import React from 'react';
import { BrandAccentToggle } from '../BrandAccentToggle/BrandAccentToggle';
import { ThemeToggle } from '../ThemeToggle/ThemeToggle';

export interface OverflowMenuAppearanceRowsProps {
  /**
   * When true, marks the first accent option for `AppearancePopover` open focus
   * (`appearancePanelInitialFocusSelector` within Content ref).
   */
  markAppearancePanelInitialFocus?: boolean;
}

/**
 * Shared Accent + Theme rows for the form overflow menu (⋮) and portal Appearance popover.
 * Uses `overflow-menu__accent-item` / `overflow-menu__theme-item` hooks in `BrandAccentToggle.css`.
 */
export const OverflowMenuAppearanceRows: React.FC<OverflowMenuAppearanceRowsProps> = ({
  markAppearancePanelInitialFocus = false,
}) => (
  <>
    <div className="overflow-menu__accent-item border-t border-gray-200 dark:border-[#404040] flex items-center justify-between gap-3 min-h-[2.75rem] px-4 py-2 text-[var(--text-primary)]">
      <span className="text-left shrink-0 text-sm font-medium leading-5">Accent</span>
      <BrandAccentToggle markAppearancePanelInitialFocus={markAppearancePanelInitialFocus} />
    </div>
    <div className="overflow-menu__theme-item border-t border-gray-200 dark:border-[#404040] flex items-center justify-between gap-3 h-11 min-h-[2.75rem] px-4 py-2 text-[var(--text-primary)]">
      <span className="text-left text-sm font-medium leading-5">Theme</span>
      <ThemeToggle />
    </div>
  </>
);
